module.exports = __webpack_public_path__ + "static/media/chocolate-peanut-butter-cup-deluxe.c4a9945b.png";